<template v-if="!loading">
    <v-dialog width="700px" v-model="editQdialog">
         <v-btn fab dark small color="orange" slot="activator" ><v-icon>edit</v-icon> 
        </v-btn>
        <v-card color="grey lighten-4" flat offset-md4 >
      <v-container grid-list-md pa-3>
            <v-flex xs1 style="float:right">
              <v-btn flat fab small @click="editQdialog=false;"> <v-icon>close</v-icon></v-btn>
          </v-flex>
        <v-layout row wrap>
          <v-flex xs12>
            <div style="color: purple; text-align:center;"><h4>Edit the Question</h4></div>
          </v-flex>
           <v-flex xs12>
               <v-layout row wrap>
            <v-flex xs6>
        <v-text-field
          name="intPOint"
          label="InterestPoint"
          :value="'interestPoint: '+que.point"
          readonly
          single-line
        ></v-text-field>
            </v-flex>
              <v-flex xs6>
        <v-text-field
          name="School"
          label="School"
          :value="'School Type: '+ schools[que.school_type-1]"
          readonly
          single-line
        ></v-text-field>
            </v-flex>
            <v-flex xs6>
        <v-text-field
          name="lang"
          label="lang"
          :value="'Language: '+ language"
          readonly
          single-line
        ></v-text-field>
            </v-flex>
            </v-layout>
          </v-flex>
          <v-layout row>
          <v-flex xs12>
            <v-text-field 
            name="Que" 
            label="Questions"
            id="Que"
            v-model="editQue"
            box multi-line
            required></v-text-field>
          </v-flex>
          </v-layout >
          <v-flex xs12 v-for="(item, index) in que.options" :key="index">
              <v-layout row> 
               <v-text-field
               :label="`${index+1} answer`"
            v-model="options[index]"
            required>  </v-text-field></v-layout>
          </v-flex>
          <v-flex xs12>
    <v-radio-group v-model="editCorrect">
      <v-radio
        v-for="n in que.options.length"
        :key="n"
        :label="`Σωστή απάντηση ${n}`"
        :value="n"
      ></v-radio>
    </v-radio-group>
          </v-flex>

      <div style="margin-left:44%;">
            <v-spacer></v-spacer>
          <v-btn @click="onSubmitChanges" color="red" style="color:white;" 
          :disabled="!formIsValid"
          > Edit Question </v-btn>
</div>
        </v-layout>
      </v-container>
    </v-card>
    </v-dialog>
 

</template>

<script>
export default {
  props: {que: Object},
  data () {
    return {
      schools:["Γενικής Παιδείας","Ειδικής Παιδείας"],
      editQdialog: false,
      editQue: this.que.question,
      options:this.que.options,
      editCorrect: this.que.correct,
    }
  },
  computed: {
    language(){
        if (this.que.language === '1'){
            return 'English';
        }
        else{
            return 'Greek';
        }
    },
    formIsValid () {
      if(this.editQue!==""){
          return true;
      }else{
          return false;
      }
    },
    loading(){
      return this.$store.getters.loading;
    }
  },
  methods: {
    onSubmitChanges () {
      if (!this.formIsValid) {
        return;
      }
      this.editQdialog = false;
      const queData = {
        question: this.editQue,
        options: this.options,
        correct: (this.editCorrect),
        language:this.que.language,
        id: this.que.id,
        school_type: this.que.school_type,
        theme: this.que.point,
        key: this.que.key,
        lastChangedBy: this.$store.getters.user.email
      };
      this.$store.dispatch('updateQue', queData);
      this.$store.dispatch('loadSpotContent', Number(this.$route.params.id));
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/edit-questions/edit-quest.vue